/* Generated by customizer-launch/tools/build.py from Studio's customizer.js
   plus marked host patches, DE/EN strings, the knob shader, the reveal driver
   and the preview pin. Do not edit. */

/* ==========================================================================
   Knob colouring (host layer, Max 24.09.2026: "wirkt sehr blass").
   Studio multiplied the white knob art by the swatch colour: the result was
   flat and pale, and the knurl almost vanished. This keeps the knob's own
   shading instead and rebuilds the colour around it:
     - luminance stretched around its median, shadows harder than lights,
       so knurl and pointer come through
     - hue and saturation from the swatch, depth calibrated on the real red
       product photo (top face ~ rgb 204/68/83)
     - rim darkened like a cylinder edge, top a touch lighter
     - the soft white halo of the source art dropped (alpha remap)
     - the pointer painted white on coloured knobs, like the product
   Called by tintedKnob() in trackone-customizer.js via build.py's patch.
   ========================================================================== */
(function () {
  var TUNE = {
    red: { sat: 0.66, l: -0.11 },
    green: { sat: 0.70, l: -0.12 },
    orange: { sat: 0.78, l: -0.10 },
    white: { sat: 0.25, l: -0.02 }
  };
  var DARK_GAIN = 1.55, LIGHT_GAIN = 0.5, SPREAD = 0.42, RIM = 0.36, TOP_LIGHT = 0.04;
  var POINTER = [244, 241, 234];

  function hexToHsl(hex) {
    var n = parseInt(String(hex).replace('#', ''), 16);
    var r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2, h = 0, s = 0;
    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }
    return [h, s, l];
  }

  function hue(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  window.TCKnobShade = function (ctx, w, h, color, hex) {
    var img = ctx.getImageData(0, 0, w, h);
    var d = img.data;
    var tune = TUNE[color] || TUNE.red;

    // Pass 1: box of every visible pixel, luminance histogram of the solid core.
    var bx0 = w, by0 = h, bx1 = -1, by1 = -1;
    var cx0 = w, cy0 = h, cx1 = -1, cy1 = -1;
    var hist = new Uint32Array(256), n = 0, x, y, i;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        i = (y * w + x) * 4;
        var a = d[i + 3];
        if (!a) continue;
        if (x < bx0) bx0 = x; if (x > bx1) bx1 = x; if (y < by0) by0 = y; if (y > by1) by1 = y;
        if (a > 153) {
          if (x < cx0) cx0 = x; if (x > cx1) cx1 = x; if (y < cy0) cy0 = y; if (y > cy1) cy1 = y;
          hist[(0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) | 0]++;
          n++;
        }
      }
    }
    if (!n) return;
    function pct(q) {
      var target = n * q, acc = 0;
      for (var k = 0; k < 256; k++) { acc += hist[k]; if (acc >= target) return k / 255; }
      return 1;
    }
    var p2 = pct(0.02), p50 = pct(0.5), p98 = pct(0.98);
    var range = Math.max(p98 - p2, 0.004);
    var cx = (cx0 + cx1) / 2, cy = (cy0 + cy1) / 2;
    var R = Math.max(cx1 - cx0, cy1 - cy0) / 2 || 1;

    var hsl = hexToHsl(hex);
    var H = hsl[0], S0 = clamp(hsl[1] * tune.sat, 0, 1), L0 = hsl[2] + tune.l;
    var paintPointer = color !== 'white';

    // Pass 2: recolour inside the box.
    for (y = by0; y <= by1; y++) {
      for (x = bx0; x <= bx1; x++) {
        i = (y * w + x) * 4;
        var al = d[i + 3] / 255;
        if (!al) continue;
        var L = (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255;
        var t = (L - p50) / range;
        t = t < 0 ? t * DARK_GAIN : t * LIGHT_GAIN;
        var dx = (x - cx) / R, dy = (y - cy) / R, r = Math.sqrt(dx * dx + dy * dy);
        var sm = clamp((r - 0.72) / 0.28, 0, 1);
        sm = sm * sm * (3 - 2 * sm);
        var lo = clamp((L0 + t * SPREAD - dy * TOP_LIGHT) * (1 - RIM * sm), 0.03, 0.96);
        var so = clamp(S0 * (1 - Math.abs(lo - 0.5) * 0.5), 0, 1);
        var q = lo < 0.5 ? lo * (1 + so) : lo + so - lo * so, p = 2 * lo - q;
        var rr = hue(p, q, H + 1 / 3) * 255, gg = hue(p, q, H) * 255, bb = hue(p, q, H - 1 / 3) * 255;
        if (paintPointer && Math.abs(dx) < 0.12 && dy < -0.45 && r < 0.84) {
          var wgt = clamp((p50 - L - 0.08) / 0.5, 0, 1);
          if (wgt > 0) {
            rr += (POINTER[0] - rr) * wgt; gg += (POINTER[1] - gg) * wgt; bb += (POINTER[2] - bb) * wgt;
          }
        }
        d[i] = rr; d[i + 1] = gg; d[i + 2] = bb;
        d[i + 3] = clamp((al - 0.15) / 0.7, 0, 1) * 255;
      }
    }
    ctx.putImageData(img, 0, 0);
  };
})();

/* ==========================================================================
   TRACKONE — Loopstation Customizer engine
   Dependency-free. Progressive enhancement over server-rendered radios.
   Layered <img> preview · <canvas> knob colorization · one-request cart.
   ========================================================================== */

(() => {
  'use strict';

  const NS = (window.TrackoneCustomizer = window.TrackoneCustomizer || {});
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     Pure helpers (exposed for tests)
     ------------------------------------------------------------------ */
  const KNOB_COLORS = ['white', 'orange', 'red', 'green'];

  const pure = {
    parseParams(search) {
      const q = new URLSearchParams(search || '');
      const clean = (v) => (v || '').toString().trim().toLowerCase();
      const color = (v) => {
        const c = clean(v).replace('505', '').replace(/[^a-z]/g, '');
        return KNOB_COLORS.includes(c) ? c : null;
      };
      const cov = clean(q.get('savers'));

      // Big knobs: `bigl`/`bigr` mean split (independent) mode; a lone `big`
      // means identical (both sides same). No split params => identical.
      const bl = color(q.get('bigl'));
      const br = color(q.get('bigr'));
      const bigSplit = q.has('bigl') || q.has('bigr');
      const bigOne = color(q.get('big'));

      // Small knobs: `s1..s4` mean split; a lone `small` means identical (all 4).
      const s = [color(q.get('s1')), color(q.get('s2')), color(q.get('s3')), color(q.get('s4'))];
      const smallSplit = q.has('s1') || q.has('s2') || q.has('s3') || q.has('s4');
      const smallOne = color(q.get('small'));

      return {
        skin: q.has('skin') ? clean(q.get('skin')) : null,
        bigIdentical: !bigSplit,
        bigLeft: bigSplit ? bl : bigOne,
        bigRight: bigSplit ? br : bigOne,
        smallIdentical: !smallSplit,
        small1: smallSplit ? s[0] : smallOne,
        small2: smallSplit ? s[1] : smallOne,
        small3: smallSplit ? s[2] : smallOne,
        small4: smallSplit ? s[3] : smallOne,
        savers: cov === 'full' || cov === 'half' ? cov : q.has('savers') ? 'full' : null
      };
    },

    buildQuery(state) {
      const q = new URLSearchParams();
      const col = (t) => (t && t.color) ? t.color : null;
      const ident = state.identical || { big: true, small: true };
      if (state.skin && state.skin.key) q.set('skin', state.skin.key);

      // Big: identical => single `big`; split => `bigl`/`bigr`.
      if (ident.big) {
        const c = col(state.bigLeft) || col(state.bigRight);
        if (c) q.set('big', c);
      } else {
        if (col(state.bigLeft)) q.set('bigl', col(state.bigLeft));
        if (col(state.bigRight)) q.set('bigr', col(state.bigRight));
      }

      // Small: identical => single `small`; split => `s1..s4`.
      if (ident.small) {
        const c = col(state.small1) || col(state.small2) || col(state.small3) || col(state.small4);
        if (c) q.set('small', c);
      } else {
        [1, 2, 3, 4].forEach((i) => { const c = col(state['small' + i]); if (c) q.set('s' + i, c); });
      }

      if (state.savers) q.set('savers', state.savers.coverage || 'full');
      const s = q.toString();
      return s ? '?' + s : '';
    },

    cartItems(state) {
      // Aggregate by variant id so two big knobs of the SAME colour collapse to
      // one line at quantity 2, while two DIFFERENT colours stay two lines of 1.
      const order = ['skin', 'bigLeft', 'bigRight', 'small1', 'small2', 'small3', 'small4', 'savers'];
      const byId = {};
      const items = [];
      order.forEach((k) => {
        const tier = state[k];
        if (!tier || !tier.variantId) return;
        const id = Number(tier.variantId);
        if (byId[id]) { byId[id].quantity += 1; return; }
        const item = { id: id, quantity: 1 };
        byId[id] = item;
        items.push(item);
      });
      return items;
    },

    eur(cents) {
      const n = (Number(cents) || 0) / 100;
      // host (shop): the format Liquid's money filter uses on this very page, read
      // from a sample the section renders ("€1.234,56", "1.234,56 zł"). Studio always
      // wrote €, also when the cart ran in another currency.
      const el = document.querySelector('[data-cz-money]');
      const sample = el ? el.getAttribute('data-cz-money') : '';
      const m = sample && sample.match(/1([.,\u00a0\u202f' ]?)234([.,])56/);
      if (m) {
        const parts = n.toFixed(2).split('.');
        const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
        return sample.slice(0, m.index) + int + m[2] + parts[1] + sample.slice(m.index + m[0].length);
      }
      return '€' + n.toFixed(2).replace('.', ',');
    }
  };
  NS._pure = pure;

  /* ------------------------------------------------------------------
     Instance
     ------------------------------------------------------------------ */
  function init(root) {
    if (!root || root.dataset.czReady) return;
    root.dataset.czReady = '1';

    let config = {};
    try {
      const el = root.querySelector('[data-cz-config]');
      config = el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      config = {};
    }
    const assets = config.assets || {};
    const tints = config.tints || { orange: '#FF9937', red: '#F85A65', green: '#6EE1A4' };
    // host (shop): strings per language from the section config, English as fallback.
    const strings = config.strings || {};
    const tr = (key, en) => (Object.prototype.hasOwnProperty.call(strings, key) ? strings[key] : en);
    const colourName = (c) => tr('color_' + c, cap(c));
    // host (shop): customizer discount (Max, 24.09.). The code is limited to the
    // customizer's products in the admin; it goes on the cart once a build lands
    // there. Codes already on the cart stay.
    const discount = config.discount || {};
    // host (shop): the phone summary is one row (total + button); the long label
    // with the price did not fit there, the total stands right next to it anyway.
    const mqNarrow = window.matchMedia('(max-width: 979px)');
    if (mqNarrow.addEventListener) mqNarrow.addEventListener('change', () => renderSummary());
    async function applyDiscount() {
      if (!discount.code) return;
      try {
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const cart = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const mine = String(discount.code).toUpperCase();
        const codes = (cart.discount_codes || []).map((d) => d.code).filter((c) => c && String(c).toUpperCase() !== mine);
        codes.push(discount.code);
        await fetch(base + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        });
      } catch (e) {}
    }

    const $ = (sel) => root.querySelector(sel);
    const $$ = (sel) => Array.prototype.slice.call(root.querySelectorAll(sel));

    const stage = $('[data-cz-stage]');
    const layers = {
      skin: $('[data-cz-layer="skin"]'),
      bigLeft: $('[data-cz-layer="bigLeft"]'),
      bigRight: $('[data-cz-layer="bigRight"]'),
      small1: $('[data-cz-layer="small1"]'),
      small2: $('[data-cz-layer="small2"]'),
      small3: $('[data-cz-layer="small3"]'),
      small4: $('[data-cz-layer="small4"]'),
      savers: $('[data-cz-layer="savers"]')
    };
    const shimmer = $('[data-cz-shimmer]');
    const chipsEl = $('[data-cz-chips]');
    const totalEl = $('[data-cz-total]');
    const wasEl = $('[data-cz-total-was]');
    const addBtn = $('[data-cz-add]');
    const addLabel = $('[data-cz-add-label]');
    const feedback = $('[data-cz-feedback]');

    const state = {
      skin: null,
      bigLeft: null, bigRight: null,
      small1: null, small2: null, small3: null, small4: null,
      savers: null,
      identical: { big: true, small: true }
    };

    /* ---------- Knob colorization (canvas → objectURL, cached) ---------- */
    const tintCache = {}; // `${tier}:${color}` -> objectURL
    const canvasOK = (() => {
      try {
        const c = document.createElement('canvas');
        return !!(c.getContext && c.getContext('2d'));
      } catch (e) {
        return false;
      }
    })();

    const CSS_FILTER = {
      // fallback only — approximate, keeps the page alive if canvas/CORS fails
      orange: 'brightness(1) sepia(1) saturate(6) hue-rotate(-12deg)',
      red: 'brightness(1) sepia(1) saturate(7) hue-rotate(-32deg)',
      green: 'brightness(1) sepia(1) saturate(4) hue-rotate(90deg)'
    };

    function loadImage(src, cors) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        if (cors) img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    }

    async function tintedKnob(tier, color) {
      const key = tier + ':' + color;
      if (tintCache[key]) return { url: tintCache[key], filtered: false };
      const src =
        tier === 'bigLeft' ? assets.knobBigLeft :
        tier === 'bigRight' ? assets.knobBigRight :
        tier === 'small1' ? assets.knobSmall1 :
        tier === 'small2' ? assets.knobSmall2 :
        tier === 'small3' ? assets.knobSmall3 :
        tier === 'small4' ? assets.knobSmall4 :
        assets.knobSmall;
      if (!src) throw new Error('no-asset');
      // host (shop): white is shaded too (crisp edge, rim), see knob-shade.js.
      if (!canvasOK || !window.TCKnobShade) {
        return color === 'white' ? { url: src, filtered: false } : { url: src, filtered: true, filter: CSS_FILTER[color] };
      }
      try {
        const img = await loadImage(src, true);
        const c = document.createElement('canvas');
        c.width = img.naturalWidth || 1680;
        c.height = img.naturalHeight || 1200;
        const ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0);
        // host (shop): realistic shading instead of a flat multiply, see knob-shade.js.
        window.TCKnobShade(ctx, c.width, c.height, color, color === 'white' ? '#F4F1EA' : (tints[color] || '#ffffff'));
        const url = await new Promise((res, rej) => {
          if (c.toBlob) c.toBlob((b) => (b ? res(URL.createObjectURL(b)) : rej(new Error('blob'))), 'image/webp', 0.9);
          else res(c.toDataURL('image/png'));
        });
        tintCache[key] = url;
        return { url: url, filtered: false };
      } catch (e) {
        // canvas tainted or decode failed → CSS filter fallback
        return { url: src, filtered: true, filter: CSS_FILTER[color] || '' };
      }
    }

    /* ---------- Layer painting ---------- */
    function showShimmer(on) {
      if (!shimmer) return;
      if (on && !reduced) shimmer.hidden = false;
      else shimmer.hidden = true;
    }

    async function paintSkin() {
      const layer = layers.skin;
      if (!layer) return;
      if (!state.skin || !state.skin.image) {
        layer.classList.remove('is-on');
        layer.removeAttribute('src');
        return;
      }
      showShimmer(true);
      try {
        const img = await loadImage(state.skin.image, false);
        if (img.decode) {
          try { await img.decode(); } catch (e) {}
        }
        layer.src = state.skin.image;
        layer.classList.add('is-on');
      } catch (e) {
        layer.classList.remove('is-on');
      } finally {
        showShimmer(false);
      }
    }

    async function paintKnob(tier) {
      const layer = layers[tier];
      if (!layer) return;
      const sel = state[tier];
      if (!sel || !sel.color) {
        layer.classList.remove('is-on');
        layer.style.filter = '';
        layer.removeAttribute('src');
        return;
      }
      try {
        const res = await tintedKnob(tier, sel.color);
        layer.src = res.url;
        layer.style.filter = res.filtered ? res.filter : '';
        layer.classList.add('is-on');
      } catch (e) {
        layer.classList.remove('is-on');
      }
    }

    function paintSavers() {
      const layer = layers.savers;
      if (!layer) return;
      if (!state.savers) {
        layer.classList.remove('is-on');
        layer.removeAttribute('src');
        return;
      }
      const src = state.savers.coverage === 'half' ? assets.saversHalf : assets.saversFull;
      if (src) {
        layer.src = src;
        layer.classList.add('is-on');
      }
    }

    /* ---------- Summary + total ---------- */
    // host (shop): Shopify takes the percentage per cart line and rounds per line.
    function discountedTotal() {
      const pct = Number(discount.percent) || 0;
      if (!discount.code || !pct) return total();
      const lines = {};
      ['skin', 'bigLeft', 'bigRight', 'small1', 'small2', 'small3', 'small4', 'savers'].forEach((k) => {
        const s = state[k];
        if (s && s.price && s.variantId) lines[s.variantId] = (lines[s.variantId] || 0) + Number(s.price);
      });
      let cents = 0;
      Object.keys(lines).forEach((id) => { cents += lines[id] - Math.round(lines[id] * pct / 100); });
      return cents;
    }

    function total() {
      let cents = 0;
      ['skin', 'bigLeft', 'bigRight', 'small1', 'small2', 'small3', 'small4', 'savers'].forEach((k) => {
        if (state[k] && state[k].price) cents += Number(state[k].price);
      });
      return cents;
    }

    function renderSummary() {
      if (!chipsEl) return;
      const chips = [];
      if (state.skin) chips.push({ t: state.skin.title, c: 'red' });
      // Big knobs — one chip that adapts to identical / split.
      (function () {
        const bl = state.bigLeft, br = state.bigRight;
        if (!bl && !br) return;
        if (state.identical.big && bl) { chips.push({ t: tr('chip_big', 'Big knobs') + ' · ' + colourName(bl.color), c: bl.color }); return; }
        const parts = [bl ? colourName(bl.color) : tr('stock', 'Stock'), br ? colourName(br.color) : tr('stock', 'Stock')];
        chips.push({ t: tr('chip_big', 'Big knobs') + ' · ' + parts.join(' / '), c: (bl || br).color });
      })();
      // Small knobs — one chip; collapses when every set knob is the same colour.
      (function () {
        const sm = [state.small1, state.small2, state.small3, state.small4].filter(Boolean);
        if (!sm.length) return;
        const uniq = [];
        sm.forEach((t) => { if (uniq.indexOf(t.color) === -1) uniq.push(t.color); });
        const label = tr('chip_small', 'Small knobs') + ' · ' + (uniq.length === 1 ? colourName(uniq[0]) : tr('n_colours', '{n} colours').replace('{n}', uniq.length));
        chips.push({ t: label, c: sm[0].color });
      })();
      if (state.savers) chips.push({ t: tr('chip_savers', 'Button Blackouts'), c: 'green' });

      chipsEl.innerHTML = '';
      if (!chips.length) {
        const s = document.createElement('span');
        s.className = 'cz__chip cz__chip--empty';
        s.textContent = tr('empty', 'Stock RC-505 MKII, nothing added yet');
        chipsEl.appendChild(s);
      } else {
        chips.forEach((ch) => {
          const s = document.createElement('span');
          s.className = 'cz__chip cz__chip--' + ch.c;
          s.textContent = ch.t;
          chipsEl.appendChild(s);
        });
      }

      // host (shop): discounted total, the full one struck through next to it.
      const full = total(), net = discountedTotal();
      if (totalEl) totalEl.textContent = pure.eur(net);
      if (wasEl) { wasEl.hidden = !(net < full); wasEl.textContent = net < full ? pure.eur(full) : ''; }

      const items = pure.cartItems(state);
      if (addBtn) {
        addBtn.disabled = items.length === 0;
        if (addLabel) {
          addLabel.textContent = items.length === 0
            ? tr('pick', 'Pick at least a skin to start')
            : (mqNarrow.matches ? tr('add_short', 'Add to cart') : tr('add', 'Add build to cart for {total}').replace('{total}', pure.eur(discountedTotal())));
        }
      }
      updateStepperDone();
      updatePills();
    }

    function cap(s) {
      return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
    }

    function updateStepperDone() {
      const anyKnob = state.bigLeft || state.bigRight || state.small1 || state.small2 || state.small3 || state.small4;
      const map = { skin: !!state.skin, knobs: !!anyKnob, savers: !!state.savers };
      $$('[data-cz-jump]').forEach((n) => {
        n.classList.toggle('is-done', !!map[n.dataset.czJump]);
      });
    }

    function updatePills() {
      const setPill = (name, on, label) => {
        const el = root.querySelector('[data-cz-pick="' + name + '"]');
        if (el) {
          el.textContent = on ? label : tr('optional', 'Optional');
          el.classList.toggle('is-set', on);
        }
      };
      setPill('skin', !!state.skin, state.skin ? tr('selected', 'Selected') : '');
      const anyBig = state.bigLeft || state.bigRight;
      const anySmall = state.small1 || state.small2 || state.small3 || state.small4;
      const knobN = (anyBig ? 1 : 0) + (anySmall ? 1 : 0);
      setPill('knobs', knobN > 0, tr('n_set', '{n} set').replace('{n}', knobN));
      setPill('savers', !!state.savers, tr('added', 'Added'));
    }

    /* ---------- State setters ---------- */
    function setSkin(key, meta) {
      if (!key) {
        state.skin = null;
      } else {
        state.skin = {
          key: key,
          variantId: meta.variantId,
          price: meta.price,
          title: meta.title,
          url: meta.url,
          image: meta.image
        };
      }
      paintSkin();
      renderSummary();
      syncURL();
    }

    function setKnob(tier, color, meta) {
      if (!color) state[tier] = null;
      else state[tier] = { color: color, variantId: meta.variantId, price: meta.price, title: meta.title };
      paintKnob(tier);
      renderSummary();
      syncURL();
    }

    function setSavers(on, meta, coverage) {
      if (!on) state.savers = null;
      else state.savers = {
        variantId: meta.variantId,
        price: meta.price,
        title: meta.title,
        coverage: coverage || (state.savers && state.savers.coverage) || 'full'
      };
      paintSavers();
      renderSummary();
      syncURL();
    }

    /* ---------- URL sync ---------- */
    let urlTimer = null;
    function syncURL() {
      if (!window.history || !history.replaceState) return;
      clearTimeout(urlTimer);
      urlTimer = setTimeout(() => {
        const q = pure.buildQuery(state);
        try {
          history.replaceState(null, '', location.pathname + q + (location.hash || ''));
        } catch (e) {}
      }, 120);
    }

    /* ---------- Bind the server-rendered inputs ---------- */
    function selectSkinByKey(key) {
      const input = root.querySelector('[data-cz-skin-input][value="' + cssEscape(key) + '"]');
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    function selectKnobByColor(tier, color) {
      const input = root.querySelector('[data-cz-knob-input][data-tier="' + tier + '"][value="' + cssEscape(color) + '"]');
      if (input && !input.disabled) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    function selectMasterByColor(group, color) {
      const input = root.querySelector('[data-cz-master-input][data-group="' + group + '"][value="' + cssEscape(color) + '"]');
      if (input && !input.disabled) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    function cssEscape(v) {
      return (v || '').toString().replace(/["\\]/g, '\\$&');
    }

    $$('[data-cz-skin-input]').forEach((input) => {
      input.addEventListener('change', (e) => {
        if (!input.checked) return;
        setSkin(input.value, {
          variantId: input.dataset.variantId,
          price: input.dataset.price,
          title: input.dataset.title,
          url: input.dataset.url,
          image: input.dataset.image
        });
        markSelected('[data-cz-skin-input]', input, '.cz__skin');
        // Answering the skin question reveals the knobs question.
        if (e.isTrusted) scheduleAdvance('knobs');
      });
    });

    // Helpers to keep the master swatch and the per-knob (split) radios in sync.
    function subTiersOf(group) {
      return group === 'big' ? ['bigLeft', 'bigRight'] : ['small1', 'small2', 'small3', 'small4'];
    }
    function reflectTierRadio(tier, color) {
      const input = root.querySelector('[data-cz-knob-input][data-tier="' + tier + '"][value="' + cssEscape(color || '') + '"]');
      if (input) input.checked = true;
    }
    function reflectMasterRadio(group, color) {
      const input = root.querySelector('[data-cz-master-input][data-group="' + group + '"][value="' + cssEscape(color || '') + '"]');
      if (input) input.checked = true;
    }

    // Independent (split-mode) per-knob radios.
    $$('[data-cz-knob-input]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        setKnob(input.dataset.tier, input.value, {
          variantId: input.dataset.variantId,
          price: input.dataset.price,
          title: input.dataset.title
        });
      });
    });

    // Master radios: one choice paints every sub-knob in the group (identical mode).
    $$('[data-cz-master-input]').forEach((input) => {
      input.addEventListener('change', (e) => {
        if (!input.checked) return;
        const group = input.dataset.group;
        const meta = { variantId: input.dataset.variantId, price: input.dataset.price, title: input.dataset.title };
        subTiersOf(group).forEach((tier) => {
          setKnob(tier, input.value, meta);
          reflectTierRadio(tier, input.value);
        });
        // Small is the last knob question → gently reveal savers.
        if (e.isTrusted && group === 'small') scheduleAdvance('savers');
      });
    });

    // "Identical" checkbox: collapse to one master swatch, or fan out per-knob.
    function setIdentical(group, on) {
      state.identical[group] = on;
      const master = root.querySelector('[data-cz-master="' + group + '"]');
      const split = root.querySelector('[data-cz-split="' + group + '"]');
      const row = root.querySelector('[data-cz-group="' + group + '"]');
      if (master) master.hidden = !on;
      if (split) split.hidden = on;
      if (row) row.classList.toggle('is-split', !on);
      const tiers = subTiersOf(group);
      if (on) {
        // Collapse: every knob snaps to the first knob's colour.
        const primary = state[tiers[0]];
        const color = primary ? primary.color : '';
        const meta = primary ? { variantId: primary.variantId, price: primary.price, title: primary.title } : {};
        tiers.forEach((tier) => { setKnob(tier, color, meta); reflectTierRadio(tier, color); });
        reflectMasterRadio(group, color);
      } else {
        // Expand: make each split radio reflect the current tier colour.
        tiers.forEach((tier) => reflectTierRadio(tier, state[tier] ? state[tier].color : ''));
      }
      renderSummary();
      syncURL();
    }
    function applyIdentical(group, on) {
      const cb = root.querySelector('[data-cz-identical="' + group + '"]');
      if (cb) cb.checked = on;
      setIdentical(group, on);
    }
    $$('[data-cz-identical]').forEach((cb) => {
      cb.addEventListener('change', () => setIdentical(cb.dataset.czIdentical, cb.checked));
    });

    const saverInput = $('[data-cz-saver-input]');
    const covWrap = $('[data-cz-cov-wrap]');
    if (saverInput) {
      saverInput.addEventListener('change', () => {
        setSavers(saverInput.checked, {
          variantId: saverInput.dataset.variantId,
          price: saverInput.dataset.price,
          title: saverInput.dataset.title
        });
        if (covWrap) covWrap.hidden = !saverInput.checked;
      });
    }
    $$('[data-cz-cov]').forEach((btn) => {
      btn.addEventListener('click', () => {
        $$('[data-cz-cov]').forEach((b) => b.classList.toggle('is-active', b === btn));
        if (state.savers) setSavers(true, state.savers, btn.dataset.czCov);
      });
    });

    function markSelected(sel, active, wrapSel) {
      $$(sel).forEach((i) => {
        const wrap = i.closest(wrapSel);
        if (wrap) wrap.classList.toggle('is-selected', i === active);
      });
    }

    /* ---------- Mobile full-screen overlay ---------- */
    const overlay = $('[data-cz-overlay]');
    const overlayGrid = $('[data-cz-overlay-grid]');
    const expandBtn = $('[data-cz-expand]');
    let lastFocus = null;

    function buildOverlay() {
      if (!overlayGrid) return;
      overlayGrid.innerHTML = '';
      $$('[data-cz-skin-input]').forEach((input) => {
        if (input.value === '') return;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cz__ov-cell';
        const img = input.closest('.cz__skin').querySelector('img');
        btn.innerHTML =
          '<span class="cz__ov-media">' + (img ? '<img src="' + img.src + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="cz__ov-name">' + (input.dataset.title || '') + '</span>';
        btn.addEventListener('click', () => {
          selectSkinByKey(input.value);
          closeOverlay();
          scheduleAdvance('knobs');
        });
        overlayGrid.appendChild(btn);
      });
    }

    function openOverlay() {
      if (!overlay) return;
      buildOverlay();
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.documentElement.classList.add('cz-lock');
      requestAnimationFrame(() => overlay.classList.add('is-open'));
      const close = overlay.querySelector('[data-cz-overlay-close]');
      if (close) close.focus();
      document.addEventListener('keydown', onOverlayKey);
    }

    function closeOverlay() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('cz-lock');
      document.removeEventListener('keydown', onOverlayKey);
      // Hide after the slide-out. Guard with a timeout so a missed transitionend
      // (reduced motion, interrupted transition) can never leave the fixed overlay
      // covering the page.
      let hidden = false;
      const done = () => {
        if (hidden) return;
        hidden = true;
        clearTimeout(fallback);
        overlay.removeEventListener('transitionend', done);
        overlay.hidden = true;
      };
      const fallback = setTimeout(done, reduced ? 0 : 520);
      if (!reduced) overlay.addEventListener('transitionend', done);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onOverlayKey(e) {
      if (e.key === 'Escape') { closeOverlay(); return; }
      if (e.key === 'Tab') {
        const f = overlay.querySelectorAll('button');
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    if (expandBtn) expandBtn.addEventListener('click', openOverlay);
    if (overlay) {
      overlay.querySelector('[data-cz-overlay-close]').addEventListener('click', closeOverlay);
      overlay.addEventListener('click', (e) => { if (e.target === overlay) closeOverlay(); });
    }
    // expander only matters on narrow screens
    const mq = window.matchMedia('(max-width: 979px)');
    const syncExpand = () => { if (expandBtn) expandBtn.hidden = !mq.matches; };
    syncExpand();
    (mq.addEventListener ? mq.addEventListener('change', syncExpand) : mq.addListener(syncExpand));

    /* ---------- Sticky stepper: clickable pills + prev/next arrows ---------- */
    const STEP_ORDER = ['skin', 'knobs', 'savers'];
    const stepper = $('[data-cz-stepper]');
    const prevBtn = $('[data-cz-prev]');
    const nextBtn = $('[data-cz-next]');
    const steps = {};
    STEP_ORDER.forEach((k) => { steps[k] = root.querySelector('[data-cz-step="' + k + '"]'); });
    let activeStep = 'skin';

    function stickyOffset() {
      // Clear everything pinned above the steps: site nav + the stepper, plus —
      // on the stacked mobile layout — the compact preview that also pins there.
      // host (Refresh): its header height; Studio had a fixed 56px nav.
      const navH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const gap = 14;
      let off = navH + gap + (stepper ? stepper.getBoundingClientRect().height : 56);
      const preview = root.querySelector('.cz__preview');
      if (preview && window.matchMedia('(max-width: 979px)').matches) {
        off += preview.getBoundingClientRect().height + gap;
      }
      return off;
    }

    function jumpToStep(key) {
      const el = steps[key];
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset();
      try {
        window.scrollTo({ top: Math.max(0, y), behavior: reduced ? 'auto' : 'smooth' });
      } catch (e) {
        window.scrollTo(0, Math.max(0, y));
      }
      setActiveStep(key);
    }

    function setActiveStep(key) {
      if (!STEP_ORDER.includes(key)) return;
      activeStep = key;
      $$('[data-cz-jump]').forEach((p) => {
        const on = p.dataset.czJump === key;
        p.classList.toggle('is-active', on);
        if (on) p.setAttribute('aria-current', 'step');
        else p.removeAttribute('aria-current');
      });
      const i = STEP_ORDER.indexOf(key);
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= STEP_ORDER.length - 1;
    }

    // Auto-advance: after a selection, gently swipe the next question into view.
    // Debounced so picking two knob colours in a row only scrolls once, and
    // gated on `autoAdvanceReady` so URL hydration doesn't scroll on load.
    let advanceTimer = null;
    let autoAdvanceReady = false;
    function scheduleAdvance(targetStep) {
      if (!autoAdvanceReady || !steps[targetStep]) return;
      clearTimeout(advanceTimer);
      advanceTimer = setTimeout(() => jumpToStep(targetStep), 520);
    }

    $$('[data-cz-jump]').forEach((pill) => {
      pill.addEventListener('click', () => { clearTimeout(advanceTimer); jumpToStep(pill.dataset.czJump); });
    });
    if (prevBtn) prevBtn.addEventListener('click', () => {
      clearTimeout(advanceTimer);
      const i = STEP_ORDER.indexOf(activeStep);
      if (i > 0) jumpToStep(STEP_ORDER[i - 1]);
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      clearTimeout(advanceTimer);
      const i = STEP_ORDER.indexOf(activeStep);
      if (i < STEP_ORDER.length - 1) jumpToStep(STEP_ORDER[i + 1]);
    });

    // Scroll-spy: highlight the pill for whichever step is under the sticky bar.
    if ('IntersectionObserver' in window) {
      const spy = new IntersectionObserver(
        (entries) => {
          // choose the most-visible intersecting step
          let best = null;
          entries.forEach((e) => {
            if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) best = e;
          });
          if (best) {
            const key = best.target.getAttribute('data-cz-step');
            if (key && key !== activeStep) setActiveStep(key);
          }
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: [0, 0.25, 0.5, 1] }
      );
      STEP_ORDER.forEach((k) => { if (steps[k]) spy.observe(steps[k]); });
    }
    setActiveStep('skin');

    /* ---------- Add to cart (one request, all tiers) ---------- */
    let busy = false;
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        if (busy) return;
        const items = pure.cartItems(state);
        if (!items.length) return;
        busy = true;
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.disabled = true;
        const restore = addLabel ? addLabel.textContent : '';
        if (addLabel) addLabel.textContent = tr('adding', 'Adding…');
        hideFeedback();
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!res.ok) {
            let msg = tr('err_add', 'That didn’t go through. Please try again.');
            try { const j = await res.json(); if (j && j.description) msg = j.description; } catch (e) {}
            throw new Error(msg);
          }
          await applyDiscount();
          await refreshCartCount();
          if (addLabel) addLabel.textContent = tr('added_ok', 'Build added ✓');
          showFeedback(tr('in_cart', 'Your build is in the cart.') + ' <a href="' + ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart">' + tr('view_cart', 'View cart &rarr;') + '</a>', false);
          setTimeout(() => { if (addLabel) addLabel.textContent = restore; addBtn.disabled = false; }, 3500);
        } catch (e) {
          if (addLabel) addLabel.textContent = restore;
          addBtn.disabled = false;
          showFeedback((e && e.message) || tr('err_generic', 'Something went wrong. Try again.'), true);
        } finally {
          busy = false;
          addBtn.removeAttribute('aria-busy');
        }
      });
    }

    async function refreshCartCount() {
      // host (Refresh): re-render its cart bubble through the Section Rendering API.
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        try {
          const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const json = await fetch(base + '?sections=cart-icon-bubble').then((r) => r.json());
          const doc = new DOMParser().parseFromString(json['cart-icon-bubble'] || '', 'text/html');
          const inner = doc.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        } catch (e) {}
        return;
      }
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const link = document.querySelector('.site-nav__cart');
        if (link) {
          let count = link.querySelector('.site-nav__count');
          if (!count) {
            count = document.createElement('span');
            count.className = 'site-nav__count';
            link.appendChild(count);
          }
          count.textContent = cart.item_count;
        }
      } catch (e) {}
    }

    function showFeedback(html, isError) {
      if (!feedback) return;
      feedback.innerHTML = html;
      feedback.hidden = false;
      if (isError) feedback.setAttribute('data-error', '');
      else feedback.removeAttribute('data-error');
    }
    function hideFeedback() {
      if (feedback) feedback.hidden = true;
    }

    /* ---------- Prefetch skins after first interaction ---------- */
    let prefetched = false;
    function prefetchSkins() {
      if (prefetched) return;
      prefetched = true;
      const ric = window.requestIdleCallback || ((fn) => setTimeout(fn, 400));
      ric(() => {
        $$('[data-cz-skin-input]').forEach((input) => {
          if (input.dataset.image) {
            const i = new Image();
            i.src = input.dataset.image;
          }
        });
      });
    }
    root.addEventListener('pointerdown', prefetchSkins, { once: true, passive: true });

    /* ---------- Cross-section delegation ---------- */
    function handleExternal(el) {
      let hit = false;
      if (el.dataset.customizeSkin != null) hit = selectSkinByKey(el.dataset.customizeSkin) || hit;
      // Legacy single trigger colours BOTH big knobs; explicit L/R triggers also work.
      if (el.dataset.customizeBig != null) {
        hit = selectKnobByColor('bigLeft', el.dataset.customizeBig) || hit;
        hit = selectKnobByColor('bigRight', el.dataset.customizeBig) || hit;
      }
      if (el.dataset.customizeBigLeft != null) hit = selectKnobByColor('bigLeft', el.dataset.customizeBigLeft) || hit;
      if (el.dataset.customizeBigRight != null) hit = selectKnobByColor('bigRight', el.dataset.customizeBigRight) || hit;
      // A single trigger colours all four small knobs (identical).
      if (el.dataset.customizeSmall != null) {
        ['small1', 'small2', 'small3', 'small4'].forEach((t) => { hit = selectKnobByColor(t, el.dataset.customizeSmall) || hit; });
      }
      if (el.dataset.customizeSavers != null) {
        if (saverInput && !saverInput.disabled) {
          saverInput.checked = true;
          saverInput.dispatchEvent(new Event('change', { bubbles: true }));
          const covBtn = root.querySelector('[data-cz-cov="' + cssEscape(el.dataset.customizeSavers) + '"]');
          if (covBtn) covBtn.click();
          hit = true;
        }
      }
      if (hit) scrollToSection();
      return hit;
    }

    NS._external = handleExternal;

    function scrollToSection() {
      try {
        root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      } catch (e) {
        root.scrollIntoView();
      }
    }

    /* ---------- Hydrate from URL ---------- */
    function hydrate() {
      const p = pure.parseParams(location.search);
      let any = false;
      if (p.skin) { if (selectSkinByKey(p.skin)) any = true; }

      // Big knobs: identical → drive the master; split → drive each side.
      if (!p.bigIdentical) applyIdentical('big', false);
      if (p.bigIdentical) {
        if (p.bigLeft && selectMasterByColor('big', p.bigLeft)) any = true;
      } else {
        if (p.bigLeft && selectKnobByColor('bigLeft', p.bigLeft)) any = true;
        if (p.bigRight && selectKnobByColor('bigRight', p.bigRight)) any = true;
      }

      // Small knobs: identical → master; split → each of the four.
      if (!p.smallIdentical) applyIdentical('small', false);
      if (p.smallIdentical) {
        if (p.small1 && selectMasterByColor('small', p.small1)) any = true;
      } else {
        [1, 2, 3, 4].forEach((i) => { if (p['small' + i] && selectKnobByColor('small' + i, p['small' + i])) any = true; });
      }
      if (p.savers && saverInput && !saverInput.disabled) {
        saverInput.checked = true;
        saverInput.dispatchEvent(new Event('change', { bubbles: true }));
        const covBtn = root.querySelector('[data-cz-cov="' + p.savers + '"]');
        if (covBtn) covBtn.click();
        any = true;
      }
      if (any) setTimeout(scrollToSection, 60);
    }

    renderSummary();
    hydrate();
    // Enable auto-advance only after the initial (URL-driven) state is applied,
    // so hydration never yanks the page around on load.
    autoAdvanceReady = true;
  }

  /* ------------------------------------------------------------------
     Boot + cross-section delegation + design-mode re-init
     ------------------------------------------------------------------ */
  function boot() {
    document.querySelectorAll('[data-customizer]').forEach(init);
  }

  // One document-level listener routes external triggers to the instance.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest(
      '[data-customize-skin],[data-customize-big],[data-customize-big-left],[data-customize-big-right],[data-customize-small],[data-customize-savers]'
    );
    if (!trigger || !NS._external) return;
    // let same-page anchor scroll be superseded by our smooth scroll
    const handled = NS._external(trigger);
    if (handled && trigger.getAttribute('href') === '#' ) e.preventDefault();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector ? e.target.querySelector('[data-customizer]') : null;
    if (sec) { delete sec.dataset.czReady; init(sec); }
  });
})();

/* ==========================================================================
   Reveal on scroll — the part of Studio's trackone.js the customizer uses,
   scoped to the section. Refresh has no [data-reveal] of its own.
   ========================================================================== */
(() => {
  'use strict';

  function run() {
    const groups = document.querySelectorAll('.cz[data-reveal-group]');
    if (!groups.length) return;
    const items = [];
    groups.forEach((group) => {
      group.querySelectorAll('[data-reveal]').forEach((el, i) => {
        if (!el.style.getPropertyValue('--reveal-delay')) el.style.setProperty('--reveal-delay', String(i));
        items.push(el);
      });
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Also reveal anything already above the viewport, after a
          // scroll-restored reload or an anchor jump.
          if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.02, rootMargin: '0px' }
    );
    items.forEach((el) => io.observe(el));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Theme editor: a re-rendered section brings fresh, unrevealed markup.
  document.addEventListener('shopify:section:load', run);
})();

/* ==========================================================================
   Keep the loopstation pinned through the last step (host layer, Max
   24.09.2026: "am Ende des Scrolls scrollt sich die Loopstation weg").
   The sticky preview can only travel as far as its grid row reaches. Step 03
   (Button Blackouts) is short, so the stepper's jump to it scrolled the row's
   end above the pinned preview and the loopstation slid away. The steps
   column gets the tail it needs (--cz-tail, read by the host CSS):
     desktop  the row reaches past the pinned preview while step 03 sits
              where the stepper puts it
     mobile   the row reaches the bottom of the screen at that point, so the
              stacked preview stays put until you scroll past the customizer
   ========================================================================== */
(function () {
  var GAP = 14; // jumpToStep's gap under the stepper
  var MARGIN = 24;

  function px(v) { return parseFloat(v) || 0; }

  function fit(root) {
    var steps = root.querySelector('[data-cz-steps]');
    var last = root.querySelector('[data-cz-step="savers"]');
    var preview = root.querySelector('.cz__preview');
    var stepper = root.querySelector('[data-cz-stepper]');
    if (!steps || !last || !preview) return;

    function update() {
      var header = px(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      var stepperH = stepper ? stepper.getBoundingClientRect().height : 0;
      var previewH = preview.getBoundingClientRect().height;
      var lastH = last.getBoundingClientRect().height;
      var mobile = window.matchMedia('(max-width: 979px)').matches;
      // Where jumpToStep() puts a step (its offset always counts the header).
      var land = header + GAP + stepperH + (mobile ? previewH + GAP : 0);
      var need;
      if (mobile) {
        need = window.innerHeight - (land + lastH);
      } else {
        // Pinned top with the header shown is the lowest the preview sits.
        var top = px(getComputedStyle(preview).top);
        var shown = document.querySelector('.shopify-section-header-sticky:not(.shopify-section-header-hidden)');
        if (!shown) top += header;
        need = top + previewH + MARGIN - (land + lastH);
      }
      steps.style.setProperty('--cz-tail', Math.max(0, Math.ceil(need)) + 'px');
    }

    update();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(update);
      ro.observe(preview);
      ro.observe(last);
      if (stepper) ro.observe(stepper);
    }
    window.addEventListener('resize', update, { passive: true });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-customizer]'), fit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
